export interface IProduct {
  productId?: string,
  quantity: number,
  displayQuantity?: number,
  multiplier?: number,
  name: string,
  unit: "szt." | "g",
  capacity: number,
  imageUrl?: string,
  bought?: boolean,
  id?: string
}

export interface IMeal {
  id?: string,
  name: string,
  quantity?: number,
  imageUrl?: string,
  ingredients: IProduct[],
  type: "breakfast" | "lunch" | "dinner" | "snack",
  weekday?: WeekDaysEnum
}

export enum WeekDaysEnum {
  "monday" = "monday",
  "tuesday" = "tuesday",
  "wednesday" = "wednesday",
  "thursday" = "thursday",
  "friday" = "friday",
  "saturday" = "saturday",
  "sunday" = "sunday",
}

export type ActivePageType = "home" | "cart" | "menu" | "list" | "settings"
